/* eslint-disable */
import React, { useState, useEffect } from 'react'
import 'antd/dist/antd.css'
import { connect } from 'react-redux'
import { Menu, Layout, Input, Breadcrumb, Radio, Spin, BackTop } from 'antd'
import { saveLoginInfo, clearLoginInfo } from '../redux/auth'
import { useDispatch } from 'react-redux'
import { UpOutlined } from '@ant-design/icons';
import MarketCard from 'components/MarketCard'
import { history } from 'redux/store'
import { storageData, clearstorageData } from 'redux/storage'
import { Col, Row } from 'antd'
import { Carousel, Divider  } from 'antd';
import PageHeader from "components/PageHeader";
import { useTranslation } from 'react-i18next'
import displayimg from 'images/Marketdisplay.png'
import { GetSubscriptions, guestGetSubscriptions, frontendGetSubscriptions, GetService, guestGetService, getLookupCode, guestGetServicev2 } from 'api/hub';
import MyFooter from "components/MyFooter";
import ServiceCard from 'components/ServiceCard'

const Marketdetail = (props) => {
  // console.log(props)
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const [Service, setService] = useState(null)
  const [visible, setVisible] = useState(1)
  const [Subscription, setSubscription] = useState({})
  const [Preorderstatus, setPreorderstatus] = useState("N")
  const [statuscode, setstatuscode] = useState({
    status_desc_en: "",
    status_desc_tw: ""
  })
  const [isfree, setisfree] = useState(false)
  const [issubscription, setsubscription] = useState(false)
  const [Subscriptiondata, setSubscriptiondata] = useState({
    service_media:"",
    service_name_en: "",
    service_name_tw:"",
    vendor_name: "",
    period_start: "",
    period_end: "",
    tag: "",
    rate: 0,
    reviews: 0,
    summary: "",
    icon_url:""
  })
 
  useEffect(()=>{
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString)
    const serviceId = urlParams.get('serviceId')?urlParams.get('serviceId'):""
    let anchorElement = document.getElementById('top');
    // 如果對應id的錨點存在，就跳轉到錨點
    // console.log(anchorElement)
    if(anchorElement) { anchorElement.scrollIntoView({block: 'start', behavior: 'smooth'}); }
    // console.log(serviceId)
    setLoading(true)
    // dispatch(guestGetSubscriptions({service_id:serviceId})).then(
    //     res => { 
    //       if(Object.keys(res).length > 2){
    //         setSubscription(() => res.data.subscriptions[0]) 
    //       }
    //       setLoading(false)
    //      }
    //     )
    // dispatch(guestGetService({service_id:serviceId})).then(
    //   res => { 
    //       setLoading(false)
    //       setService(()=>(res.data.services[0]))
    //     }
    //   )
    const LoginInfo = JSON.parse(localStorage.getItem('LoginInfo'))
    if(LoginInfo){
      dispatch(guestGetServicev2({service_id:serviceId, tenant_id:LoginInfo.tenantId})).then(
        res => { 
            setstatuscode(res.data.services[0].preorder)
            setLoading(false)
            setService(()=>(res.data.services[0]))
            if(res.data.services[0].overview_data[0].isfree === "Y"){
              setisfree(()=>true)
            }
            if(res.data.services[0].subscription !== "N"){
              setsubscription(()=>true)
              const tenantId = JSON.parse(localStorage.getItem('LoginInfo')).tenantId
              const operator_id = JSON.parse(localStorage.getItem('LoginInfo')).operator_id
              dispatch(GetSubscriptions(
                {
                  "tenant_id": tenantId,
                  "ip_address": "1.1.1.1",
                  "operator_id": operator_id,
                  "service_id": serviceId,
                }
                ))
              .then(
                  res => { 
                    var lookup = res.data.subscriptions.lookup_data
                    lookup.map(item=>{
                      if(item.lookup_code === res.data.subscriptions.subscription_data[0].status) {
                        setstatuscode(item)
                      }
                    })
                    if(Object.keys(res).length > 2){
                        if(res.data.subscriptions.subscription_data[0].status !== "active"){
                            // history.push("/")
                        }
                      setSubscriptiondata(() => res.data.subscriptions.subscription_data[0]) 
                    }
                    setLoading(false)
                   }
                  )
            }

          }
        )
    } else {
      dispatch(guestGetServicev2({service_id:serviceId})).then(
        res => { 
            setLoading(false)
            setService(()=>(res.data.services[0]))
            if(res.data.services[0].overview_data[0].isfree === "Y"){
              setisfree(()=>true)
            }
          }
        )
        }
    }
  ,[])
  

  const options = [
    { label: `${t('Subscription.Detail.overview')}`, value: 'Id1' },
    { label: `${t('Subscription.Detail.pricing')}`, value: 'Id2' },
    { label: `${t('Subscription.Detail.details_and_support')}`, value: 'Id3' },
    // { label: `${t('Subscription.Detail.ratings_and_reviews')}`, value: '4' , disabled: true}
  ]

  const onNav=()=>{
    const url = new URL(window.location.href)
    const searchValue = url.searchParams.get("search")?url.searchParams.get("search"):""
    history.push(`/?search=${searchValue}`)
  }

  const onChange = e => {
    let anchorElement = document.getElementById(e.target.value === 'Id1' ? 'top' : e.target.value);
    // 如果對應id的錨點存在，就跳轉到錨點
    if(anchorElement) { anchorElement.scrollIntoView({block: (e.target.value === 'Id1' ? 'start' : e.target.value === 'Id2' ? 'center' :'end'), behavior: 'smooth'}); }
  }
  
  const { Header, Footer, Sider, Content } = Layout;

  return (
    <>
    <Header id='top'>
        <PageHeader/>
      </Header>
      <Spin tip={t('Global.Loading')} spinning={loading} style={{padding: '36px 0 0 130px'}}>
      <Content style={{height:'95vh'}}>
      <div className='wrapM' style={{padding:'0px'}} id='backWrapId'>
        {!loading && Service ?
        <div className='innerlayoutM' style={{padding:'50px 5vw',width: '100%', maxWidth:'1920px', margin:'auto'}}>
            <Breadcrumb separator=">">
              <Breadcrumb.Item><a onClick={onNav} style={{color:'#7DB926'}}> WiAdvance App Market</a></Breadcrumb.Item>
              <Breadcrumb.Item className='lastchild'>{localStorage.getItem('lang')==='en'?`${Service.service_info_data_en[0].service_name}`:`${Service.service_info_data_tw[0].service_name}`}</Breadcrumb.Item>
            </Breadcrumb>
            <div className='headtitle'>
              {localStorage.getItem('lang')==='en'?`${Service.service_info_data_en[0].service_name}`:`${Service.service_info_data_tw[0].service_name}`}
            </div>
            {
              issubscription?<ServiceCard data={{
                ...Subscriptiondata,
                'sub_status': statuscode
              }
              }></ServiceCard>:
              <MarketCard data={{
                ...Service,
                'service_name_en':Service.service_info_data_en[0].service_name,
                'service_name_tw':Service.service_info_data_tw[0].service_name,
                'summary_tw':Service.service_info_data_tw[0].summary,
                'summary_en':Service.service_info_data_en[0].summary,
                'isfree': isfree,
                'sub_status': statuscode
              }} type='market'></MarketCard>
            }
            <div className='servicedetailradio'>
              <Radio.Group 
                  defaultValue="Id1"
                  optionType="button"
                  buttonStyle="solid"
                  options={options}
                  onChange={onChange} 
                  />
            </div>
            <div className='servicedescription'>
              <Row>
            
                <div className='left'>
                  <div className='title'>
                    {t('Subscription.Detail.product_overview')}
                  </div>
                  <div className='par'>
                    {Service.service_info_data_tw ? localStorage.getItem('lang')==='en'?
                    Service.service_info_data_en[0].promotional_text ?<div  style={{paddingBottom:'10px'}}><div contentEditable='false' dangerouslySetInnerHTML={{ __html: `${Service.service_info_data_en[0].promotional_text}` }}></div><br/></div>:
                    null:
                    Service.service_info_data_tw[0].promotional_text ?<div  style={{paddingBottom:'10px'}}><div contentEditable='false' dangerouslySetInnerHTML={{ __html: `${Service.service_info_data_tw[0].promotional_text}` }}></div><br/></div>:
                    null
                    : null}
                    <div contentEditable='false' dangerouslySetInnerHTML={{ __html: `${Service.service_info_data_tw ? localStorage.getItem('lang')==='en'?`${Service.service_info_data_en[0].description}`:`${Service.service_info_data_tw[0].description}` :''}` }}></div>
                    
                  </div>
                  
                </div>
            
                <div className='right'>
                  <div className='title'>
                    {t('Subscription.Detail.preview')}
                  </div>
                    <div className='carousel'>
                      <Carousel autoplay>
                          {
                            Service.media_data?
                            Service.media_data.sort((a, b) => {
                              if(a.media_type === 'mediaLink'){
                                return -1
                              }
                              if (a.media_type === 'screenshot'){
                                return 1;
                              }
                              return 0;
                            }
                            ).map(item=>{
                              if(item.media_type === 'mediaLink') {
                                return <><div><iframe width='100%' style={{aspectRatio: '16/9'}} src={item.media_url.replace("watch?v=","embed/")} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div></>
                              } else if(item.media_type === 'screenshot') {
                                return <><div><img width='100%' style={{aspectRatio: '16/9'}} src={item.media_url} alt="photo"></img></div></>
                              }
                            }):<></>
                          
                          }
                        </Carousel>
                    </div>
                    <div className='title' id='Id2'>
                        {t('Subscription.Detail.pricing')}
                    </div>
                    <div className='cost'>
                      <div className='costinfo'>
                      <div contentEditable='false' dangerouslySetInnerHTML={{ __html: `${Service.service_info_data_tw ? localStorage.getItem('lang')==='en'?`${Service.service_info_data_en[0].price_info}`:`${Service.service_info_data_tw[0].price_info}` : ''}` }}></div>
                      
                      </div>
                    </div>
                    <div className='sup' id='Id3'>
                      <div className='title'>
                        {t('Subscription.Detail.details_and_support')}
                      </div>
                      <div className='supblock'>
                        <div className='marginblock'>
                          {Service.support_data_v2? Service.support_data_v2.map(i=>{
                          if(!i.info[localStorage.getItem('lang')].col_val){
                            return(<></>)
                          }
                          else if(i.type === "mailto"){
                              return(
                                <div className='block'>
                                  <div className='left'>
                                    {i.info[localStorage.getItem('lang')].col_name}
                                  </div>
                                  <a className='right' onClick={()=>window.open(`mailto:${i.info[localStorage.getItem('lang')].link1}`)}>
                                    {i.info[localStorage.getItem('lang')].link1_title}
                                  </a>
                                </div>
                              )
                            }
                            else if(i.type === "append_alink" || i.type === "alink"){
                              return(
                              <div className='block'>
                              <div className='left'>
                                {i.info[localStorage.getItem('lang')].col_name}
                              </div>
                              <div className='right' style={{color:'#3F3F3F'}}>
                                
                                {i.info[localStorage.getItem('lang')].col_val.split(/\s?{link[1-9]}+{link[1-9]_title(.*?)}\s?/g).map((item,index)=>{
                                  // console.log(index,item)
                                if(index % 2 === 1){
                                  // console.log((index+1) / 2 )
                                  return (<a className='right' onClick={()=>window.open(`${i.info[localStorage.getItem('lang')][`link${(index+1) / 2}`]}`)}>
                                    {i.info[localStorage.getItem('lang')][`link${(index+1) / 2}_title`]}
                                  </a>)
                                }else{
                                  // {console.log(item)}
                                  return (
                                    <>{item}</>
                                  )
                                }
                              })
                              }
                              </div>
                              </div>
                              )
                            }
                            else{
                              return(
                              <div className='block'>
                                <div className='left'>
                                  {i.info[localStorage.getItem('lang')].col_name}
                                </div>
                                <div className='rightg'>
                                  {i.info[localStorage.getItem('lang')].col_val}
                                </div>
                              </div>
                              )
                            }
                            
                          }):
                          null}
                        </div>
                      </div>
                    </div>
            
                </div>
                          
                <Row 
                justify='end'
                align='bottom'
                >
                </Row>
                <BackTop>
                  <div style={{
                    width:'60px',
                    height:'60px',
                    borderRadius:'50%',
                    backgroundColor:'#ffffff',
                    color:'#7DB926',
                    textAlign:'center',
                    cursor: 'pointer',
                    padding:'5px',
                    fontWeight: 900,
                    border:'solid 2px #C7C7C7'
                  }}><UpOutlined style={{
                    fontSize: '16px',
                  }}/><br/>{t('Global.TOP')}</div>
                </BackTop>
              </Row>
            </div>
            {/* <Divider /> */}
        </div>:<div className='innerlayoutM' style={{padding:'50px 5vw',width: '100%', height:'95vh'}}>
            <Breadcrumb separator=">">
              <Breadcrumb.Item><a style={{color:'#7DB926'}}> WiAdvance App Market</a></Breadcrumb.Item>
            </Breadcrumb>
            <div className='servicedetailradio'>
                        <Radio.Group 
                            defaultValue="Id1"
                            optionType="button"
                            buttonStyle="solid"
                            options={options}
                            onChange={onChange} 
                            />
                      </div>
            </div>
            }
      </div>
      
      <MyFooter />
      </Content>
      </Spin>


    </>
  )
}
// 將store中的items值傳綁到props上
const mapStateToProps = store => (
  { storeData: store.storeData }
)
const mapDispatchToProps = dispatch => {
  return {
    storageData: (payload) => {
      dispatch(storageData(payload))
    },
    clearstorageData: () => {
      dispatch(clearstorageData())
    }
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(Marketdetail)